import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/marcador-consumo-alimentar`;

    return {
        autocomplete(queryParms = {}) {
            return repository.get(`${baseUrl}/autocomplete?${urlUtil.serialize(queryParms)}`);
        },
        historico(id) {
            return repository.get(`${baseUrl}/historico-atendimento/${id}`);
        },
        create(id) {
            return repository.get(`${baseUrl}/create/${id}`);
        },
        store(params) {
            return repository.post(`${baseUrl}`, params);
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`);
        },
        update(id, params) {
            return repository.put(`${baseUrl}/${id}`, params);
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        getUnidades(queryParms) {
            return repository.get(`${baseUrl}/unidade?${urlUtil.serialize(queryParms)}`)
        },
        getInfraestruturas(queryParms) {

            return repository.get(`${baseUrl}/infraestrutura?${urlUtil.serialize(queryParms)}`)
        },
        getEquipes(queryParms) {
            return repository.get(`${baseUrl}/equipe?${urlUtil.serialize(queryParms)}`)
        },
        getOcupacoes(queryParms) {
            return repository.get(`${baseUrl}/ocupacao?${urlUtil.serialize(queryParms)}`)
        },
    }
}
